import React, { useState } from 'react';
import './Wishlist.css';

function Wishlist() {
  // Categories for filtering
  const categories = [
    { id: 'all', name: 'Все' },
    { id: 'toys', name: 'Игрушки' },
    { id: 'clothes', name: 'Одежда' },
    { id: 'books', name: 'Книги' },
    { id: 'development', name: 'Развитие' }
  ];
  
  // Demo wishlist items
  const [wishlistItems, setWishlistItems] = useState([
    {
      id: 1,
      name: 'Мягкая игрушка "Мишка"',
      category: 'toys',
      priority: 'high',
      isGifted: false,
      description: 'Мягкий плюшевый мишка размером 30см.'
    },
    {
      id: 2,
      name: 'Книга "Сказки на ночь"',
      category: 'books',
      priority: 'medium',
      isGifted: false,
      description: 'Сборник коротких сказок с красивыми иллюстрациями.'
    },
    {
      id: 3,
      name: 'Комбинезон на 6-9 месяцев',
      category: 'clothes',
      priority: 'high',
      isGifted: true,
      description: 'Теплый комбинезон на осень-зиму.'
    },
    {
      id: 4,
      name: 'Развивающий коврик',
      category: 'development',
      priority: 'high',
      isGifted: false,
      description: 'Коврик с различными текстурами и звуковыми элементами.'
    },
    {
      id: 5,
      name: 'Погремушка',
      category: 'toys',
      priority: 'low',
      isGifted: true,
      description: 'Яркая погремушка с удобной ручкой.'
    },
    {
      id: 6,
      name: 'Книга "Первые слова"',
      category: 'books',
      priority: 'medium',
      isGifted: false,
      description: 'Книга с крупными картинками и простыми словами.'
    }
  ]);
  
  const [selectedCategory, setSelectedCategory] = useState('all');
  
  // Toggle gifted status
  const toggleGiftedStatus = (id) => {
    setWishlistItems(wishlistItems.map(item => 
      item.id === id ? { ...item, isGifted: !item.isGifted } : item
    ));
  };
  
  // Filter items by category
  const filteredItems = selectedCategory === 'all' 
    ? wishlistItems 
    : wishlistItems.filter(item => item.category === selectedCategory);
  
  return (
    <div className="container">
      <h1 className="page-title">Вишлист</h1>
      
      <div className="wishlist-description">
        <p>
          Здесь собраны подарки, которые хотелось бы получить Софии. 
          Если вы планируете что-то подарить, можете отметить подарок как "Уже подарен", 
          чтобы другие знали, что этот подарок уже никто не должен покупать.
        </p>
      </div>
      
      <div className="wishlist-filters">
        {categories.map(category => (
          <button
            key={category.id}
            className={`filter-button ${selectedCategory === category.id ? 'active' : ''}`}
            onClick={() => setSelectedCategory(category.id)}
          >
            {category.name}
          </button>
        ))}
      </div>
      
      <div className="wishlist-grid">
        {filteredItems.map(item => (
          <div 
            key={item.id} 
            className={`wishlist-card ${item.isGifted ? 'gifted' : ''}`}
          >
            <div className="wishlist-card-content">
              <h3>{item.name}</h3>
              <div className="wishlist-category">{categories.find(c => c.id === item.category)?.name}</div>
              <div className={`wishlist-priority ${item.priority}`}>
                Приоритет: {item.priority === 'high' ? 'Высокий' : item.priority === 'medium' ? 'Средний' : 'Низкий'}
              </div>
              <p className="wishlist-description">{item.description}</p>
            </div>
            <div className="wishlist-card-actions">
              <button 
                className={`gift-toggle-button ${item.isGifted ? 'gifted' : ''}`}
                onClick={() => toggleGiftedStatus(item.id)}
              >
                {item.isGifted ? 'Уже подарен' : 'Отметить подаренным'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Wishlist; 